import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);

export const BROCHURE_URL = `${API}/brochure`;

export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password });

export const fetchLeads = (token, type) =>
  axios.get(`${API}/admin/leads`, {
    headers: { Authorization: `Bearer ${token}` },
    params: type && type !== "all" ? { type } : {},
  });

export const fetchStats = (token) =>
  axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } });

export const deleteLead = (token, id) =>
  axios.delete(`${API}/admin/leads/${id}`, { headers: { Authorization: `Bearer ${token}` } });

export const exportLeads = (token) =>
  axios.get(`${API}/admin/leads/export`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

// Blog
export const fetchBlog = () => axios.get(`${API}/blog`);
export const fetchPost = (slug) => axios.get(`${API}/blog/${slug}`);
export const adminFetchPosts = (token) =>
  axios.get(`${API}/admin/blog`, { headers: { Authorization: `Bearer ${token}` } });
export const createPost = (token, data) =>
  axios.post(`${API}/admin/blog`, data, { headers: { Authorization: `Bearer ${token}` } });
export const updatePost = (token, id, data) =>
  axios.put(`${API}/admin/blog/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
export const deletePost = (token, id) =>
  axios.delete(`${API}/admin/blog/${id}`, { headers: { Authorization: `Bearer ${token}` } });

export const uploadImage = (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/upload-image`, fd, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const apiError = (e, fallback = "Something went wrong. Please try again.") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return fallback;
};
